import React, { useState, useEffect } from 'react';
import KBList from "./KBList.js";
import { Box } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import {getQueryParamValue, getParkedDomain} from "../App/utils";
import { RecommendedApps } from "./RecommendedApps";

import Divider from '@mui/material/Divider';

export const KBListPage = ({ hideIfEmpty, userProfile }) => {
    const [myKBs, setMyKBs] = useState(null);
    const [sharedWithMeKBs, setSharedWithMeKBs] = useState(null);
    const navigate = useNavigate();

    const onSuccessMyKBs = (data) => {
        setMyKBs(data);
    };

    const onSuccessSharedWithMe = (data) => {
        setSharedWithMeKBs(data);
    };

    const WHITELABEL_KB_ID = 'i8c8xk1s74pq';

    useEffect(() => {
        if (myKBs?.length === 0 && sharedWithMeKBs?.length === 0) {
            if (getParkedDomain()) {
                navigate('/app-center');
            } else if (!getParkedDomain() && userProfile?.signupVersion === 2) {
                if (sessionStorage.getItem('skipAutoInstall')) return;
                navigate(`/install/${WHITELABEL_KB_ID}?publishedKbId=${WHITELABEL_KB_ID}`);
            }
        }
    }, [myKBs, sharedWithMeKBs, navigate, userProfile]);

    return (
        <>
{getQueryParamValue('recommend') && <>
                <Divider style={{ paddingBottom: 15 }}> Recommended Apps </Divider>
                <Box>
                    <RecommendedApps />
                </Box>
            </>}

            <KBList hideIfEmpty={true} onSuccess={onSuccessMyKBs} userProfile={userProfile} />

            <KBList hideIfEmpty={hideIfEmpty} onSuccess={onSuccessSharedWithMe} sharedWithMe={true} />
        </>
    );
};